<article class="page-container flex flex-column">
  <section class="pb-2">
    <button pButton icon="fas fa-plus" class="p-button-info p-button-outlined" [pTooltip]="screen.actions.add"
      (click)="openModal()">
    </button>
  </section>

  <p-accordion styleClass="hide-from-small pb-2 accordion__tab--no-margin" expandIcon="far fa-eye"
    collapseIcon="far fa-eye-slash">
    <p-accordionTab class="m-0" [header]="screen.labels.filters">
      <label for="dtMobileDocumentFilter">{{screen.labels.document}}</label>
      <div>
        <input pInputText type="text" name="dtMobileDocumentFilter" [(ngModel)]="dtDocumentFilter"
          (input)="dt.filter(dtDocumentFilter, 'document', 'contains')" validation>
      </div>

      <label for="dtMobileNameFilter">{{screen.labels.name}}</label>
      <div>
        <input pInputText type="text" name="dtMobileNameFilter" [(ngModel)]="dtNameFilter"
          (input)="dt.filter(dtNameFilter, 'fullName', 'contains')" validation>
      </div>
    </p-accordionTab>
  </p-accordion>

  <section class="inline-flex">
    <p-table #dt [value]="patients.content" [lazy]="true" (onLazyLoad)="lazyReadPatients($event)" [paginator]="true"
      [rows]="pageSize" [totalRecords]="patients.totalElements" [loading]="loading" dataKey="id" [contextMenu]="cm"
      [(contextMenuSelection)]="selectedPatient" class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup class="hide-on-small">
          <col data-id="expander" [style.width.px]="50">
          <col data-id="status" [style.width.px]="50">
          <col data-id="documentType" [style.width.px]="125">
          <col data-id="document" [style.width.px]="175">
          <col data-id="name">
          <col data-id="age" [style.width.px]="225" class="hide-on-medium">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th colspan="2" rowspan="2"></th>
          <th colspan="2" class="text-center">{{screen.labels.document}}</th>
          <th class="text-center">{{screen.labels.name}}</th>
          <th class="text-center hide-on-medium" [attr.rowspan]="200">{{screen.labels.age}}</th>
        </tr>
        <tr>
          <th [attr.colspan]="2">
            <input pInputText type="text" name="dtDocumentFilter" [(ngModel)]="dtDocumentFilter"
              (input)="dt.filter(dtDocumentFilter, 'document', 'contains')">
          </th>
          <th>
            <input pInputText type="text" name="dtNameFilter" [(ngModel)]="dtNameFilter"
              (input)="dt.filter(dtNameFilter, 'fullName', 'contains')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-patient let-expanded="expanded">
        <tr [pContextMenuRow]="patient">
          <td class="text-center pointer" [pRowToggler]="patient">
            <i class="text-info fas" [ngClass]="{'fa-chevron-down': expanded, 'fa-chevron-right': !expanded}"></i>
          </td>
          <td class="text-center hide-on-small">
            <i class="fas fa-circle {{patient.status ? 'text-success' : 'text-danger'}}"
              [pTooltip]="patient.status ? screen.labels.enabled : screen.labels.disabled"></i>
          </td>
          <td>{{patient.documentTypeName}}</td>
          <td>{{patient.document}}</td>
          <td>{{patient.fullName}}</td>
          <td class="hide-on-medium">
            <ms-string-split [toSplit]="patient.age" [isDate]="true"></ms-string-split>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-patient>
        <tr [pContextMenuRow]="patient">
          <td class="hide-on-medium" [attr.colspan]="6">
            <ng-template *ngTemplateOutlet="expander; context: {$implicit: patient}"></ng-template>
          </td>

          <td class="hide-from-medium" [attr.colspan]="5">
            <ng-template *ngTemplateOutlet="expander; context: {$implicit: patient}"></ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="hide-on-medium" [attr.colspan]="6">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>

          <td class="hide-from-medium" [attr.colspan]="5">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <section class="align-self-end">
    <ms-table-paged-footer [page]="patients"></ms-table-paged-footer>
  </section>

  <p-contextMenu #cm [model]="options"></p-contextMenu>

  <ng-template #expander let-patient>
    <section class="flex flex-column">
      <div class="inline-flex flex-wrap">
        <span class="col-12 lg:col-4 px-0 inline-flex align-items-center justify-content-center">
          {{patient.dateBorn}} - {{patient.locationBornName}}
        </span>
        <div class="col-12 px-0 inline-flex hide-from-medium">
          <label
            class="col-3 pl-0 inline-flex align-items-start m-0 field__label strong">{{screen.labels.age}}</label>
          <span class="col-9 pr-0">
            <ms-string-split [toSplit]="patient.age" [isDate]="true"></ms-string-split>
          </span>
        </div>
        <span class="col-6 lg:col-4 px-0 inline-flex align-items-center justify-content-center">
          {{patient.genderName}}
        </span>
        <span class="col-6 lg:col-4 px-0 inline-flex align-items-center justify-content-center">
          {{patient.maritalStatusName}}
        </span>
      </div>

      <div class="inline-flex flex-column md:flex-row">
        <label
          class="col-12 md:col-3 px-0 md:pr-2 inline-flex align-items-center m-0 field__label strong">{{screen.labels.clinicHistory}}</label>
        <span class="col-12 md:col-9 px-0 md:pl-2">
          {{patient.clinicHistory}}
        </span>
      </div>

      <div class="inline-flex flex-column md:flex-row">
        <label
          class="col-12 md:col-3 px-0 md:pr-2inline-flex align-items-start m-0 field__label strong">{{screen.labels.email}}</label>
        <span class="col-12 md:col-9 px-0 md:pl-2 inline-flex">
          <ms-string-split [toSplit]="patient.email" [isEmail]="true"></ms-string-split>
        </span>
      </div>

      <div class="inline-flex flex-column md:flex-row">
        <label
          class="col-12 md:col-3 px-0 md:pr-2inline-flex align-items-start m-0 field__label strong">{{screen.labels.phone}}</label>
        <span class="col-12 md:col-9 px-0 md:pl-2 inline-flex">
          <ms-string-split [toSplit]="patient.phone" [isPhone]="true"></ms-string-split>
        </span>
      </div>

      <div class="inline-flex flex-column md:flex-row">
        <label
          class="col-12 md:col-3 px-0 md:pr-2inline-flex align-items-start m-0 field__label strong">{{screen.labels.residence}}</label>
        <span class="col-12 md:col-9 px-0 md:pl-2 inline-flex">
          {{patient.residenceName}} - {{patient.address}}
        </span>
      </div>
    </section>
  </ng-template>

  <ng-template #datatableEmpty>
    <span>{{screen.labels.emptyTable}}</span>
  </ng-template>
</article>